import React from "react";
import { TextField, Select, Subheading } from "@shopify/polaris";
import "@shopify/polaris/dist/styles.css";
import "./DateField.css";

const DateField = (props) => {
  const { title, day, month, year } = props;

  return (
    <fieldset className="DateField">
      <legend className="DateField__Title">{title}</legend>
      <ul className="DateField__Inputs">
        <li className="DateField__Month">{month}</li>
        <li className="DateField__Day">{day}</li>
        <li className="DateField__Year">{year}</li>
      </ul>
    </fieldset>
  );
};

export default class DateOfBirth extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      m: "",
      d: "",
      y: "",
      options: [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "Last 7 days", value: "lastWeek" },
      ],
      monthSelected: "January",
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleChange(value, id) {
    this.setState({ [id]: value });
  }
  handleSelectChange(value) {
    this.setState({ monthSelected: value });
  }
  render() {
    const { options, monthSelected } = this.state;
    const text = require("../en.json");

    return (
      <DateField
        title={<Subheading element="p">{this.props.title}</Subheading>}
        month={
          <Select
            label="Month"
            options={text.monthOptions}
            onChange={this.handleSelectChange}
            value={monthSelected}
          />
        }
        day={
          <TextField
            id="d"
            label="Day"
            maxLength={2}
            value={this.state.d}
            onChange={this.handleChange.bind(this)}
          />
        }
        year={
          <TextField
            id="y"
            label="Year"
            maxLength={4}
            value={this.state.y}
            onChange={this.handleChange.bind(this)}
          />
        }
      />
    );
  }
}
